import { Component } from '@angular/core';
import { Platform, NavParams, ViewController, LoadingController, AlertController } from 'ionic-angular';
import { SummaryServiceProvider } from '../../../../providers/wh/summary-service';

@Component({
  selector: 'confirm-cancellation-modal',
  templateUrl: 'confirm-cancellation-modal.html',
  providers: [SummaryServiceProvider]
})
export class ConfirmCancellationModalComponent {

  data;
  expireTime: any;
  isUpdate: any;
  reason: any;

  constructor(public platform: Platform,
    public params: NavParams,
    public loadingCtrl: LoadingController,
    public summaryService: SummaryServiceProvider,
    private alertCtrl: AlertController,
    public viewCtrl: ViewController) {
    this.data = this.params.get('data');
    console.log(this.data);
    //this.data = this.params;
  }

  confirmCancellation() {
    //1158879279 
    var message = "Do you want to Cancel this Parcel";
    let alert = this.alertCtrl.create({
      title: 'Confirm',
      message: `${message}`,
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Yes',
          handler: () => {
            var payload = {
              orderNos: [this.data.orderNo],
              reason: this.reason
            }
            this.summaryService
              .cancelShipment(payload)
              .then(res => {
                console.log(res);
                this.viewCtrl.dismiss(true);
              });
          }
        }
      ]
    });
    alert.present();
  }


  dismiss() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/qdb/search-parcel/confirm-cancellation-modal/confirm-cancellation-modal.ts